import Feature from "ol/Feature";
import { Coordinate } from "ol/coordinate";
import { Point, LineString, Polygon } from "ol/geom";
import VectorLayer from "ol/layer/Vector";
import { transform } from "ol/proj";
import VectorSource from "ol/source/Vector";
import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style";
import { get as getProjection } from 'ol/proj';

export class ShowPartOpenlayers {
    private static instances: Map<string, any>;
    private map!: any;
    private drawlayer!: any;
    private drawSource!: any;
    private draw!: any;
    private snap!: any;
    private partLayer!: any;

    private constructor(map: any) {
        this.map = map;
    };
    public static getInstance(map: any){
        let id = map.getTarget();
        // console.log(id);
        if (!ShowPartOpenlayers.instances) {
            ShowPartOpenlayers.instances = new Map();
        }
        let intance = ShowPartOpenlayers.instances.get(id);
        if (!intance) {
          intance = new ShowPartOpenlayers(map);
          ShowPartOpenlayers.instances.set(id, intance);
        }
        return intance;
    };
    public static destroy() {
      (ShowPartOpenlayers.instances as any) = null;
    };
    // 取消
    public async showPartCancel(params: any){
        console.log(params);
        this.map.getAllLayers().forEach((e: any) =>{
            if (e.get("label") == params.label){
                e.getSource().getFeatures().forEach((ee: any) =>{
                    if (params.value == ""){
                        e.getSource().removeFeature(ee);
                    }else {
                        if (ee.getProperties().name == params.value){
                            e.getSource().removeFeature(ee);
                        };
                    };
                });
                // this.map.removeLayer(e);
            };
        });
    };
    // 展示
    public async showPart(params: any){
        console.log(params);
        this.map.getAllLayers().forEach((e: any) =>{
            if (e.get("label") == params.label){
                // let url = e.getSource().getUrl();// ImageArcGISRest
                let url = e.getSource().getUrls();// TileArcGISRest
                let layerNum = e.getSource().getParams().LAYERS.split(":")[1];
                let imageArcGISRestUrl;
                if (params.key == ""){
                    imageArcGISRestUrl = url + "/" + layerNum + "/query?where=" + "1" + "=" + "1" + "&f=json";//获取所有要素
                }else {
                    imageArcGISRestUrl = url + "/" + layerNum + "/query?where=" + params.key + "='" + params.value + "'&f=json";//获取指定要素
                }
                console.log(imageArcGISRestUrl);
                let ArcGISJSON;
                fetch(imageArcGISRestUrl).then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok.');
                }).then(async data => {
                    console.log(data);
                    let dataFeatures: any = data.features;
                    let featureArr: any = [];
                    console.log(dataFeatures);
                    for (let i = 0; i < dataFeatures.length; i++) {
                        let feature = await this.createdSymbol(data.geometryType, dataFeatures[i], params, data.spatialReference.latestWkid);
                        featureArr.push(feature);
                    };
                    this.partLayer = new VectorLayer({
                        source: new VectorSource({
                            features: featureArr,
                        }),
                    });
                    this.partLayer.set("label", params.label+"-"+"展示"); //设置图层唯一标识
                    this.map.addLayer(this.partLayer);
                }).catch(error => {
                    console.error('There was a problem fetching the data:', error);
                });
            }
        });

    };
    public async createdSymbol(geometryType: any, symbol: any, params: any, wkid: number){
        let feature;
        let featureStyle;
        let featureGeometry;
        switch (geometryType){
            case "esriGeometryPoint"://点
                feature = new Feature({
                    name: params.value,
                    type: "Point",
                });
                if (wkid == 4326){
                    featureGeometry = new Point([symbol.geometry.x, symbol.geometry.y]);
                }else if (wkid == 3857) {
                    featureGeometry = new Point(await this.setPoint([symbol.geometry.x, symbol.geometry.y], geometryType));
                };
                if (params.iconUrl){
                    featureStyle = new Style({
                        image: new Icon({
                            src: params.iconUrl,
                            anchor: [0.5, 1],
                            scale: params.iconScale
                        }),
                    });
                }else {
                    featureStyle = new Style({
                        image: new CircleStyle({
                            radius: params.symbol.radius || 1,
                            fill: new Fill({
                                color: params.symbol.color
                            }),
                            stroke: new Stroke({
                                color: params.symbol.color,
                                width: params.symbol.width,
                            })
                        })
                    });
                }
                break;
            case "esriGeometryPolyline"://线
                feature = new Feature({
                    name: params.value,
                    type: "LineString",
                });
                if (wkid == 4326){
                    featureGeometry = new LineString(symbol.geometry.paths[0]);
                }else if (wkid == 3857) {
                    featureGeometry = new LineString(await this.setPoint(symbol.geometry.paths[0], geometryType));
                };
                featureStyle = new Style({
                    stroke: new Stroke({
                        width: params.symbol.width,
                        color: params.symbol.color,
                    }),
                });
                break;
            case "esriGeometryPolygon"://面
                feature = new Feature({
                    // name: symbol.attributes.ZD_NAME,
                    name: params.value,
                    type: "Polygon",
                });
                if (wkid == 4326){
                    featureGeometry = new Polygon(symbol.geometry.rings);
                }else if (wkid == 3857) {
                    featureGeometry = new Polygon(await this.setPoint(symbol.geometry.rings, geometryType));
                };
                featureStyle = new Style({
                    fill: new Fill({
                        color: params.symbol.color,
                    }),
                    stroke: new Stroke({
                        width: params.symbol.outline.width,
                        color: params.symbol.outline.color,
                    }),
                });
                break;
        };
        feature?.setGeometry(featureGeometry);
        feature?.setStyle(featureStyle);
        return feature;
    };
    public async setPoint(symbol: any, geometryType?: any){
        let point;
        let ringsArr: any = [];
        let ringsArrAll = [];
        if (geometryType == "esriGeometryPoint"){
            point = await transform(symbol, 'EPSG:3857', 'EPSG:4326');
            return point;
        }else if (geometryType == "esriGeometryPolyline"){
            symbol.forEach(async(e: any) =>{
                let lonLat = await transform(e, 'EPSG:3857', 'EPSG:4326');
                ringsArr.push(lonLat);
            });
            return ringsArr;
        }else if (geometryType == "esriGeometryPolygon"){
            symbol.forEach(async(e: any) =>{
                e.forEach(async (ee: Coordinate) =>{
                    let lonLat = await transform(ee, 'EPSG:3857', 'EPSG:4326');
                    ringsArr.push(lonLat);
                });
            });
            ringsArrAll.push(ringsArr);
            return ringsArrAll;
        };
    };
    // public async colorStringToRgbaArray(colorStr: any) {
    //     const colorArray = `rgba(${colorStr})`;
    //     return colorArray;
    // };
    // private async createdSymbol(geometryType: any, symbol: any, params: any, wkid: any): Promise<Feature | undefined> {
    //     let feature:any = await this.getFeature(geometryType, symbol, wkid);
    //     console.log(feature);
    //     feature.setStyle(
    //         new Style({
    //             stroke: new Stroke({
    //                 width: params.symbol.width,
    //                 color: params.symbol.color,
    //             }),
    //             fill: new Fill({
    //                 color: params.symbol.color,
    //             }),
    //         })
    //     );
    //     return feature;
    // };
}
